import React, { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import Button from '@amzn/meridian/button';
import ButtonGroup, { ButtonOption } from '@amzn/meridian/button-group';
import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Select, { SelectOption } from '@amzn/meridian/select';
import Text from '@amzn/meridian/text';
import * as LDAP from 'src/config/LDAP';
import { ACTIVE, INACTIVE } from 'src/constants/EntityStatus';
import { useAppSelector } from 'src/store/store';
import { setSiteCapacityFormData } from 'src/store/updateSiteCapacitySlice/updateSiteCapacitySlice';
import { createSearchRegExp } from 'src/utils/searchUtils';

import ShiftList from '../shiftList/shiftList';

const SiteCapacityFormFields = () => {
  const dispatch = useDispatch();
  const { ldap } = useAppSelector((state) => state.user);
  const { siteCapacityFormData, shifts } = useAppSelector((state) => state.updateSiteCapacityPage);
  const [shiftsDropdownSearchQuery, setShiftsDropdownSearchQuery] = useState();
  const searchRegExp = createSearchRegExp(shiftsDropdownSearchQuery);
  const matchedShiftsDropdownValues = shifts
    .map((shift) => ({ label: shift.shiftCode, value: shift.shiftCode }))
    .filter((option) => !shiftsDropdownSearchQuery || searchRegExp.test(option.label));

  // cache the initial state of shift Active/Inactive. For non-admins, only show activate button when this is Inactive
  const [cachedActiveStatus, _] = useState(siteCapacityFormData?.active);

  useEffect(() => {
    const shiftNames = siteCapacityFormData?.shiftNames || [];
    const myShifts = siteCapacityFormData?.shifts || [];
    if (shiftNames.length !== myShifts.length) {
      dispatch(
        setSiteCapacityFormData({
          ...siteCapacityFormData,
          shifts: shiftNames.map((shiftCode) => {
            const existing = myShifts.filter((s) => s?.shiftCode === shiftCode);
            return existing.length > 0 ? existing[0] : shifts.filter((s) => s.shiftCode === shiftCode)[0];
          }),
        }),
      );
    }
  }, [siteCapacityFormData?.shiftNames]);

  const setIsActive = (active: string) => {
    dispatch(
      setSiteCapacityFormData({
        ...siteCapacityFormData,
        active,
      }),
    );
  };

  const isActive = siteCapacityFormData?.active === ACTIVE;

  return (
    <div>
      {ldap.includes(LDAP.ADMIN) ? (
        <Row spacingInset={'none none 300 none'}>
          <Column spacing={'300'} alignmentVertical="top">
            <Text tag="label" type="h100" color="secondary">
              Is Active?
            </Text>
            <ButtonGroup value={siteCapacityFormData?.active} onChange={setIsActive}>
              <ButtonOption value={ACTIVE}>Active</ButtonOption>
              <ButtonOption value={INACTIVE}>Inactive</ButtonOption>
            </ButtonGroup>
          </Column>
        </Row>
      ) : (
        cachedActiveStatus === INACTIVE && (
          <Row>
            <Button type={isActive ? 'primary' : 'secondary'} onClick={() => setIsActive(ACTIVE)}>
              {isActive ? 'Activated' : 'Activate'}
            </Button>
            {isActive && <Text>*Click Save to apply</Text>}
          </Row>
        )
      )}
      <Row widths={['fill']} spacingInset={'300 none 300 none'}>
        <Column spacing={'300'} alignmentVertical="top">
          <Text tag="label" type="h100" color="secondary">
            Available Shifts
          </Text>
          <Select
            searchQuery={shiftsDropdownSearchQuery}
            onSearch={setShiftsDropdownSearchQuery}
            placeholder="Add shifts available for the job"
            value={siteCapacityFormData?.shiftNames}
            onChange={(shiftNames) => {
              dispatch(setSiteCapacityFormData({ ...siteCapacityFormData, shiftNames }));
            }}
          >
            {matchedShiftsDropdownValues.map((option) => (
              <SelectOption label={option.label} value={option.value} key={option.value} />
            ))}
            {!matchedShiftsDropdownValues.length ? (
              <Column alignmentVertical="center" spacing="300" spacingInset="500">
                <Text alignment="center">No results</Text>
              </Column>
            ) : null}
          </Select>
          <ShiftList />
        </Column>
      </Row>
    </div>
  );
};

export default SiteCapacityFormFields;
